import { DxDataGridColumn } from "../models/DxDataGridColumn";

export const ReviewEmailTableColumns = [
  {
    dataField: "increaseDate",
    caption: "Increase Date",
  },
  {
    dataField: "sent",
    caption: "Sent",
  },
  {
    dataField: "customerName",
    caption: "Customer Name",
  },
  {
    dataField: "primarySalesRep",
    caption: "Sales Rep",
  },
] as DxDataGridColumn[];
